import { useA11yEnabled } from './useA11yEnabled'

export default useA11yEnabled
